var exports = {
  "k": "LeaderboardPrivacySetting.module__container___aTZadn",
  "a": "LeaderboardPrivacySetting.module__hint___aTZadn",
};

module.exports = exports;
